module.exports = __webpack_public_path__ + "static/media/civic-sandbox-inverted.cb813695.svg";